import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { Form, Errors, actions, Control } from "react-redux-form";
import {
  Button,
  Row,
  Col,
  FormControl,
  Checkbox,
  FormGroup,
} from "react-bootstrap";
import qs from "qs";
import Title from "../common/title";
import ErrorMessages from "../login/error-messages";
import RequiredPasswordMaskInput from "../common/form/elements/required-password-mask-input";
import UserTitleSelector from "../common/form/user/user-title-selector";
import UserJobTitleSelector from "../common/form/user/user-job-title-selector";
import UserFirstNameInput from "../common/form/user/user-first-name-input";
import UserLastNameInput from "../common/form/user/user-last-name-input";
import UserGenderSelector from "./user-gender-selector";
import DateOfBirthSelector from "../common/form/user/date-of-birth-selector";
import SecurityQuestionAnswer from "../common/form/user/security-question-answer-input";

import {
  getQuestions,
  saveAboutYouStaff,
  saveAboutYouOwner,
  saveAboutYouAccountManager,
  getInvitationInfo,
} from "../../actions/about-you";
import { isAdminLoggedIn } from "../../utils/tokenUtils";
import "./style.css";
import { validators } from "../../utils/validators";
import TextViewer from "../common/editor/text-viewer";
import MarketingPreferences from "./marketing-preferences";

class InformationsAboutYou extends Component {
  state = {};

  constructor(props) {
    super(props);
    const { dispatch } = this.props;

    if (props.location.search) {
      const params = qs.parse(props.location.search.slice(1));
      if (params.invitation_token) {
        this.invitation_token = params.invitation_token;
        dispatch(getInvitationInfo(params.invitation_token));
      }
    }
    dispatch(getQuestions());
  }

  componentDidMount() {
    const { dispatch, registration } = this.props;

    if (registration && this.isUserAccountManager()) {
      dispatch(actions.change('deep.about_you.user.comms_email', true));
      this.updateErrors("email", null);
      dispatch(actions.change('deep.about_you.user.email', registration.email));
      dispatch(actions.setValidity('deep.about_you.user.email', true));
    }
  }

  isUserAccountManager = () => {
    const { registration } = this.props;

    return registration && registration.user_group === 'account_manager'
  }

  onNextClicked = (payload) => {
    const { dispatch, registration } = this.props;
    const { invitation_token } = this;

    if (invitation_token) {
      dispatch(
        actions.submitFields(
          "deep.about_you.user",
          saveAboutYouStaff(payload, registration, invitation_token)
        )
      );
    } else {
      dispatch(
        actions.submitFields(
          "deep.about_you.user",
          this.isUserAccountManager()
            ? saveAboutYouAccountManager(payload, registration)
            : saveAboutYouOwner(payload, registration)
        )
      );
    }
  };

  toggleCommunication = (model, value) => {
    return (dispatch) => {
      dispatch(actions.change(model, value));

      if (model.indexOf("comms_email") > -1) {
        this.updateErrors("email", null);
        dispatch(
          actions.validate("deep.about_you.user.email", {
            required: (val) =>
              !value || validators.required(this.updateErrors, "email")(val),
          })
        );
      } else {
        this.updateErrors("mobile", null);
        dispatch(
          actions.validate("deep.about_you.user.mobile", {
            required: (val) =>
              !value || validators.required(this.updateErrors, "mobile")(val),
          })
        );
      }
    };
  };

  changeEmailMobileAction = (model, value) => {
    return (dispatch) => {
      dispatch(actions.change(model, value));
      dispatch(actions.resetValidity(model));
    };
  };

  updateErrors = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  render() {
    const {
      eircode,
      passcode,
      pay_for_performance,
      comms_email,
      comms_mobile,
      pfp,
      questions,
      t_cs1,
      t_cs2,
      t_cs3,
      formValid,
    } = this.props;
    const { invitation_token } = this;
    const {
      comms_mobile: comms_mobile_input,
      comms_email: comms_email_input,
    } = this.props.form;
    const { email, mobile } = this.state;

    if (!(eircode || passcode || invitation_token || isAdminLoggedIn() || this.isUserAccountManager())) {
      return <Redirect to="/registration/outlet" />;
    }

    return (
      <div className="about-you-container">
        <Form
          model="deep.about_you.user"
          validators={{
            "": {
              communication: () => comms_email || comms_mobile,
            },
          }}
          onSubmit={this.onNextClicked}
        >
          <Errors
            className="errors"
            model="deep.about_you.user"
            component={ErrorMessages}
          />
            <Row>
              <Col lg={12}>
                <Title>About you</Title>
                <TextViewer pageSlug="about-you" />
              </Col>
              <Col lg={6}>
                <UserTitleSelector />

                <UserFirstNameInput />

                <UserLastNameInput />
                {(!this.isUserAccountManager()) &&
                  <UserJobTitleSelector />
                }

                <DateOfBirthSelector />

                <UserGenderSelector />

                <MarketingPreferences
                  title={<h4>Marketing*</h4>}
                  type="register"
                />

                <h4>Communication preferences*</h4>
                <div>
                  The communication preference you choose will be the way we
                  contact you. You will be able to use the email and/or mobile
                  entered to access your account.
                </div>

                <br />
                <Col lg={3}>
                  <FormGroup>
                    <Control.checkbox
                      model=".comms_email"
                      changeAction={this.toggleCommunication}
                      component={Checkbox}
                      disabled={this.isUserAccountManager()}
                    >
                      email
                    </Control.checkbox>
                  </FormGroup>
                </Col>
                <Col lg={9}>
                  <FormGroup validationState={email}>
                    <Control.text
                      model=".email"
                      type="email"
                      placeholder="Email"
                      changeAction={this.changeEmailMobileAction}
                      validators={{
                        required: (val) =>
                          !comms_email ||
                          validators.required(this.updateErrors, "email")(val),
                        matches: (val) => validators.matches(
                          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                          this.updateErrors,
                          'email')(val)
                      }}
                      disabled={!comms_email || this.isUserAccountManager()}
                      component={FormControl}
                    />

                    <Errors
                      show={{ touched: true, focus: false }}
                      className="errors"
                      model=".email"
                      messages={{ required: "This field is required", matches: "Wrong format" }}
                    />
                  </FormGroup>
                </Col>
                <Col lg={3}>
                  <FormGroup>
                    <Control.checkbox
                      model=".comms_mobile"
                      changeAction={this.toggleCommunication}
                      component={Checkbox}
                    >
                      mobile
                    </Control.checkbox>
                  </FormGroup>
                </Col>
                <Col lg={9}>
                  <FormGroup validationState={mobile}>
                    <Control.text
                      model=".mobile"
                      type="tel"
                      placeholder="Mobile"
                      changeAction={this.changeEmailMobileAction}
                      validators={{
                        required: (val) =>
                          !comms_mobile ||
                          validators.required(this.updateErrors, "mobile")(val),
                      }}
                      disabled={!comms_mobile}
                      component={FormControl}
                    />
                  </FormGroup>

                  <Errors
                    show={{ touched: true, focus: false }}
                    className="errors"
                    model=".mobile"
                    messages={{ required: "This field is required" }}
                  />
                </Col>
                <Errors
                  show={() =>
                    comms_email_input.touched || comms_mobile_input.touched
                  }
                  className="errors"
                  model="deep.about_you.user"
                  messages={{
                    communication:
                      "You must select at least one communication preference.",
                  }}
                />
              </Col>

              <Col lg={6}>
                <h4>Password</h4>
                Your password must be a minimum of 8 characters and must
                contain:
                <ul>
                  <li>- One uppercase letter; </li>
                  <li>- One lowercase letter;</li>
                  <li>- One number;</li>
                  <li>- One symbol (e.g. @*&/).</li>
                </ul>
                <RequiredPasswordMaskInput
                  model=".password"
                  label=""
                  controlId="newPassword"
                />
                <RequiredPasswordMaskInput
                  model=".password_confirmation"
                  label="Confirm Password"
                  controlId="passwordConfirm"
                />
                <h4>Security questions</h4>
                <SecurityQuestionAnswer
                  questions={questions.filter(
                    (question) => question.attributes["list-number"] === 1
                  )}
                  questionModel=".security_answers_attributes[0].security_question_id"
                  answerModel=".security_answers_attributes[0].answer"
                  questionLabel="Security question 1"
                  answerLabel="Security answer 1"
                  questionControlId="userSecurityQuestion1"
                  answerControlId="userSecurityAnswer1"
                />
                <SecurityQuestionAnswer
                  questions={questions.filter(
                    (question) => question.attributes["list-number"] === 2
                  )}
                  questionModel=".security_answers_attributes[1].security_question_id"
                  answerModel=".security_answers_attributes[1].answer"
                  questionLabel="Security question 2"
                  answerLabel="Security answer 2"
                  answerPlaceHolder="Security answer 2"
                  questionControlId="userSecurityQuestion2"
                  answerControlId="userSecurityAnswer2"
                />
                <Control.checkbox model=".t_cs1" component={Checkbox}>
                  I confirm that I have read, understand and agree with the
                  programme{" "}
                  <Link to="/content-pages/terms-conditions" target="_blank">
                    terms & conditions
                  </Link>
                  .
                </Control.checkbox>
                Click{" "}
                <a href="/content-pages/privacy-policy" target="_blank">
                  here
                </a>{" "}
                to view the programme privacy policy and learn more about how
                your data is collected and used, and what cookies are in use.
                {invitation_token && pfp && (
                  <Control.checkbox model=".t_cs3" component={Checkbox}>
                    I understand and agree to the rewards{" "}
                    <Link
                      to="/content-pages/rewards-terms-conditions"
                      target="_blank"
                    >
                      terms & conditions
                    </Link>
                    .
                  </Control.checkbox>
                )}
              </Col>
              <Col lg={6}>
                <Button
                  bsStyle="primary"
                  type="submit"
                  className="red-ghost-btn float-right form-submit"
                  disabled={
                    !t_cs1 ||
                    !t_cs2 ||
                    (invitation_token && pfp && !t_cs3) ||
                    !formValid
                  }
                >
                  Next
                </Button>
              </Col>
            </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    eircode: state.aboutYou.outlet.eircode,
    passcode: state.aboutYou.outlet.passcode,
    pay_for_performance: state.aboutYou.outlet.pay_for_performance,
    customer_number: state.aboutYou.outlet.customer_number,
    pfp: state.aboutYou.outlet.reward_store,
    questions: state.aboutYou.questions,
    t_cs1: state.deep.about_you.user.t_cs1,
    t_cs2: state.deep.about_you.user.t_cs2,
    t_cs3: state.deep.about_you.user.t_cs3,
    marketing: state.deep.about_you.user.marketing,
    comms_email: state.deep.about_you.user.comms_email,
    comms_mobile: state.deep.about_you.user.comms_mobile,
    registration: state.registration,
    form: state.deep.forms.about_you.user,
    formValid: state.deep.forms.about_you.user.$form.valid,
  };
};

export default connect(mapStateToProps)(InformationsAboutYou);



// WEBPACK FOOTER //
// ./src/components/about-you/index.jsx